import { Dispatch, SetStateAction } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import { Modal, Button } from "@mui/material";
import { CustomerSupport } from "../types/General";
import { isValidInput } from "../utils/validations";

interface AddReplyModalProps {
  open: boolean;
  onClose: (id: string) => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
  selectedRow: CustomerSupport | null;
  setReply: Dispatch<SetStateAction<string>>;
  reply: string;
}

export default function AddReply({
  open,
  onClose,
  setOpen,
  selectedRow,
  reply,
  setReply,
}: AddReplyModalProps) {
  return (
    <Modal
      className="modal addReply_modal"
      open={open}
      onClose={() => setOpen(false)}
    >
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title">
            <h2>Add Reply</h2>
            <div className="btn-close" onClick={() => setOpen(false)}>
              <CloseIcon />
            </div>
          </div>
          <div className="view_page gap_p">
            <div className="w_100">
              <h6>Query Title</h6>
              <p>{selectedRow?.title || ""}</p>
            </div>
            <div className="w_100">
              <h6>Query Description</h6>
              <p>{selectedRow?.description || ""}</p>
            </div>
            <div className="w_100">
              <h6>Image</h6>
              <figure className="passport_img">
                <img
                  src={selectedRow?.url || "/static/images/placeholder.png"}
                  alt="Passport"
                />
              </figure>
            </div>
          </div>
          <form className="form" action="">
            <div className="control_group">
              <div className="section_title">
                <h2>Add Reply</h2>
              </div>
              <TextField
                placeholder="Enter Reply"
                fullWidth
                hiddenLabel
                multiline
                maxRows={5}
                minRows={5}
                value={reply}
                onChange={(val) => {
                  if (isValidInput(val.target.value)) {
                    setReply(val.target.value);
                  }
                }}
              />
            </div>
            <div className="footer_btn_flex">
              <Button className="btn btn_grey" onClick={() => setOpen(false)}>
                Cancel
              </Button>
              <Button
                className="btn btn_primary"
                onClick={() => onClose(selectedRow?._id || "")}
              >
                Submit
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
}
